<form [formGroup]="passwordForm" class="mt-11">
  <div class="flex">
    <div class="flex flex-col w-full">
      <div class="flex flex-row mb-4 w-1/2 max-sm:w-full" *ngIf="token === ''">
        <div class="col-span-1 w-full mr-3 max-sm:mr-0">
          <avla-input
            class="avla-input-focus"
            [form]="passwordForm"
            id="oldPassword"
            [icons]="{
              type: 'class',
              icon: 'visibility_off',
              change: 'visibility',
              class: 'material-symbols-rounded',
              error: ''
            }"
            type="password"
            label="Contraseña actual"
            [required]="true"
          ></avla-input>
        </div>
      </div>
      <div class="flex flex-row mb-4 w-full max-sm:flex-col max-sm:gap-4">
        <div class="col-span-1 mr-6 w-1/2 max-sm:w-full">
          <avla-input
            class="avla-input-focus"
            [form]="passwordForm"
            [onInput]="checkValid.bind(this)"
            id="newPassword"
            [icons]="{
              type: 'class',
              icon: 'visibility_off',
              change: 'visibility',
              class: 'material-symbols-rounded',
              error: ''
            }"
            type="password"
            label="Nueva contraseña"
            [required]="true"
          ></avla-input>
        </div>
        <div class="col-span-1 w-1/2 max-sm:w-full">
          <avla-input
            class="avla-input-focus"
            [form]="passwordForm"
            [onInput]="checkValid.bind(this)"
            id="repeatNewPassword"
            [icons]="{
              type: 'class',
              icon: 'visibility_off',
              change: 'visibility',
              class: 'material-symbols-rounded',
              error: ''
            }"
            type="password"
            label="Repetir contraseña"
            [required]="true"
          ></avla-input>
        </div>
      </div>
      <div *ngIf="this.validPassword !== undefined" class="ps-2">
        <div>
          <p class="text-sm text-gray-1 font-semibold">
            Seguridad de la contraseña:
            <span
              [ngClass]="
                this.validPassword ? 'text-success' : 'text-fail'
              "
              >{{ passMessage }}</span
            >
          </p>
        </div>
        <div class="text-end">
          <div *ngIf="validPassword !== undefined">
            <div class="w-64 my-1">
              <img
                *ngIf="validPassword"
                src="./assets/svg/rectangle-green.svg"
                alt="line"
              />
              <img
                *ngIf="!validPassword"
                src="./assets/svg/rectangle-red.svg"
                alt="line"
              />
            </div>
            <div class="w-64">
              <span
                [ngClass]="
                  this.validPassword ? 'text-success' : 'text-fail'
                "
                class="ml-auto text-xs font-medium"
                >{{ this.validPassword ? "Fuerte" : "Débil" }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="this.validPassword !== undefined" class="mt-4 rounded-[20px] border-[0.5px] border-light-gray p-4 shadow-card-shadow-medium bg-lighter flex flex-col gap-1">
    <p class="text-smPlus text-gray-1 font-light">Su contraseña debe:</p>
    <p class="text-smPlus font-light"
      [ngClass]="
        this.validLength === undefined
          ? 'text-black'
          : this.validLength
          ? 'text-success'
          : 'text-fail'
      "
    >
      Contener al menos 8 caracteres
    </p>
    <p class="text-smPlus font-light"
      [ngClass]="
        this.validNumber === undefined
          ? 'text-black'
          : this.validNumber
          ? 'text-success'
          : 'text-fail'
      "
    >
      Incluye al menos un número
    </p>
    <p class="text-smPlus font-light"
      [ngClass]="
        this.validUppercase === undefined
          ? 'text-black'
          : this.validUppercase
          ? 'text-success'
          : 'text-fail'
      "
    >
      Incluye al menos 1 letra mayúscula
    </p>
    <p class="text-smPlus font-light"
      [ngClass]="
        this.validSpecial === undefined
          ? 'text-black'
          : this.validSpecial
          ? 'text-success'
          : 'text-fail'
      "
    >
      Incluya al menos 1 carácter especial (!@#$%^&*)
    </p>
  </div>
  <div class="flex flex-row w-full justify-center mt-11">
    <avla-button
      class="avla-btn-primary"
      [disabled]="passwordForm.invalid"
      theme="primary"
      label="Guardar"
      (click)="save()"
    ></avla-button>
  </div>
</form>